module.exports = __WEBPACK_EXTERNAL_MODULE_167__;


//////////////////
// WEBPACK FOOTER
// external "mobx"
// module id = 167
// module chunks = 20 21